import React, { Component } from "react";
import ErrorScreen from "./ErrorScreen";

export class Logger extends Component {
  state = { hasError: null, info: null };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(err, info) {
    console.error("Errors", err, "Info", info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorScreen />;
    }
    return this.props.children;
  }
}

export default Logger;
